export enum Rag {
  red,
  amber,
  green,
}
